<template>
  <div class="withdraw-card">
    <div class="title-wrap">
      <div
        v-for="(item, index) in dataValue"
        class="item"
        :class="{ active: dataType === index }"
        :key="index"
        @click="changeType(index)"
      >
        <span>{{ item.title }}</span>
      </div>
    </div>
    <div class="overview-wrap" v-if="dataType === 0">
      <div class="data-wrap">
        <div class="title-box">
          <div class="title">收益概况</div>
          <div class="date">统计周期:{{ incomeData.date }}</div>
        </div>
        <div class="data-list-wrapper" :class="{ 'is-open': isOpen }">
          <div class="data-list">
            <div
              v-for="(item, index) of overviewData"
              :key="index"
              class="data-item"
              :class="{ active: overIndex === index }"
              @click="handleCard(index, item)"
            >
              <p class="type">{{ item.title }}</p>
              <p class="num">{{ item.value || 0 }}</p>
              <p class="prev-day">昨日 {{ item.yes || 0 }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="charts">
        <div class="title">{{ overviewData[overIndex].title }}</div>
        <div class="charts-inner relative" v-if="chartData.rows.length">
          <data-status
            v-if="chartStatusArr[overIndex].isLoading"
            status="loading"
          ></data-status>
          <template v-else>
            <ve-line
              :extend="chartExtend"
              :legend-visible="false"
              :data="chartData"
              :height="lineHieght"
              :colors="['#fd9b21']"
            >
            </ve-line>
          </template>
        </div>
        <NoData v-else />
      </div>
      <div class="income-desc">
        <div class="item" v-for="(item, index) in descData" :key="index">
          {{ item.content }}
        </div>
      </div>
    </div>
    <div class="detail-wrap" v-else-if="dataType === 1">
      <IndexPageTable> </IndexPageTable>
    </div>
    <incomeList v-else> </incomeList>
  </div>
</template>

<script>
import {
  getIncomeOverview,
  getIncomeCard,
  getIncomeDiagram,
} from '@/api/income';
import IndexPageTable from './indexPageTable';
import incomeList from './incomeList.vue';
import { chartExtend } from './chartsStyle';
import NoData from '@/components/NoData.vue';
import { _regroupWan } from '@/utils/index';
export default {
  data() {
    return {
      showPopover: false,
      loading: false,
      isShowCardPop: false,
      cardArr: [],
      dataType: 0,
      overIndex: 0,
      chartData: {
        columns: ['日期', '数据'],
        rows: [],
      },
      updateDate: '',
      dtype: 15,
      dateList: [], //定义数据显示的周期
      incomeData: {},
      dialogTitle: '本月',
      cardDetail: {},
      dataValue: [
        { title: '收益总览' },
        { title: '收益明细' },
        { title: '作品收益' },
      ],
      overviewData: [],
      chartStatusArr: [
        { isLoading: false },
        { isLoading: false },
        { isLoading: false },
        { isLoading: false },
        { isLoading: false },
        { isLoading: false },
      ],
      descData: [
        { content: '1. 以上收益数据为自然月的收入概览数据。' },
        {
          content:
            '2. 由于广告数据受广告商报价时间递延影响，因此广告总收入为预估收入，由广告曝光总次数预估所得。',
        },
        { content: '3. 收益数据将在次日10点更新。' },
        {
          content:
            '4. 若您已加入工作室并成为签约成员，此处收益为归属您个人账号的收益。成为签约成员后的收益将直接计入工作室收益之中。',
        },
        {
          content:
            '5. 若您成立签约工作室成为签约室长，您在当月的个人收益将划入工作室收益之中，请做好收益区分。',
        },
      ],
      lineHieght: '60vw',
      storDetailCard1: {
        //临时存储 本月
        ad_income: 0,
        contribution: 0,
        minipoint: 0,
        other: 0,
        total_income: 0,
      },
      storDetailCard2: {
        //临时存储 累计
        ad_income: 0,
        contribution: 0,
        minipoint: 0,
        other: 0,
        total_income: 0,
      },
    };
  },
  components: {
    IndexPageTable,
    incomeList,
    NoData,
  },
  filters: {
    regroupWan(num, toFixed) {
      if (num >= 10000) {
        return (num / 10000).toFixed(toFixed || 2) + '万';
      } else if (`${num}`.includes('.')) {
        return num.toFixed(toFixed || 2);
      } else {
        return toFixed ? Number(num).toFixed(toFixed) : num;
      }
    },
    regroupComma(val, num) {
      let str = val.toString().includes('.')
        ? val.toFixed(num).toString()
        : val.toString();
      let reg =
        str.indexOf('.') > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      let res = str.replace(reg, '$1,');
      return res;
    },
  },
  mounted() {
    this.init();
    if (new Date().getDate() < 7) {
      this.getWeekDateData();
    } else {
      this.getNatureMonthDay();
    }
  },
  methods: {
    init() {
      this.fetchIncomeOverview();
      this.fetchIncomeDiagram();
      //收益概览曝光埋点
      this.reOverviewShow();
    },
    //收益概览曝光埋点
    reOverviewShow() {
      this.$log('revenue_overview_show', 85419, { v7: 2 });
    },
    //本月收益详情点击埋点
    monthDClick() {
      this.$log('thismonth_revenue_details_click', 85420, { v7: 2 });
    },
    //切换卡片
    handleCard(index, item) {
      if (this.dataType === 0) {
        this.overIndex = index;
      } else if (this.dataType === 1) {
        this.overIndex = index;
      } else {
        this.incomeIndex = index;
      }
      this.getType(item);
      this.fetchIncomeDiagram();
    },
    //当日期小于7时，获取近一周的年月日，并将其他值初始化为0
    getWeekDateData() {
      let arr = [];
      let startDate = new Date();
      let endDate = new Date();
      startDate.setDate(endDate.getDate() - 7);
      while (endDate.getTime() - startDate.getTime() >= 0) {
        let year = startDate.getFullYear();
        let month =
          (startDate.getMonth() + 1).toString().length === 1
            ? '0' + (startDate.getMonth() + 1).toString()
            : startDate.getMonth() + 1;
        let day =
          startDate.getDate().toString().length === 1
            ? '0' + startDate.getDate()
            : startDate.getDate();
        arr.push({
          date: year + '-' + month + '-' + day,
          block: 0,
          browse: 0,
          collect: 0,
          comment: 0,
          download: 0,
          play_count: 0,
          play_time: '0',
          praise: 0,
        });
        startDate.setDate(startDate.getDate() + 1);
      }
      this.dateList = arr.slice(0, arr.length - 1);
    },
    /**
     * 获取自然月的年月日，其他默认数据为0
     * 当前日期小于1周展示近三天的数据
     **/
    getNatureMonthDay() {
      let arr = [];
      let startDate = new Date();
      let endDate = new Date();
      startDate.setDate(endDate.getDate() - new Date().getDate() + 1);
      while (endDate.getTime() - startDate.getTime() >= 0) {
        let year = startDate.getFullYear();
        let month =
          (startDate.getMonth() + 1).toString().length === 1
            ? '0' + (startDate.getMonth() + 1).toString()
            : startDate.getMonth() + 1;
        let day =
          startDate.getDate().toString().length === 1
            ? '0' + startDate.getDate()
            : startDate.getDate();
        arr.push({
          date: year + '-' + month + '-' + day,
          block: 0,
          browse: 0,
          collect: 0,
          comment: 0,
          download: 0,
          play_count: 0,
          play_time: '0',
          praise: 0,
        });
        startDate.setDate(startDate.getDate() + 1);
      }
      this.dateList = arr.slice(0, arr.length - 1);
    },
    // 获取收益折线数据
    async fetchIncomeDiagram() {
      try {
        const res = await getIncomeDiagram({
          dtype: this.dtype,
        });
        this.getChartsData(res.data.list, this.dtype);
      } catch (error) {
        console.log(error);
      }
    },
    getCardList() {
      this.overviewData = [
        {
          title: '本月累计收入',
          prop: 'money',
          value: this.regroupWan(this.incomeData.money || 0, 2),
          yes: this.incomeData.yesterday_money || 0,
        },
        {
          title: '本月迷你豆收入',
          prop: 'minibean',
          value: this.regroupWan(this.incomeData.minibean || 0, 2),
          yes: this.incomeData.yesterday_minibean || 0,
        },
        {
          title: '广告总收入',
          prop: 'ad_income',
          value: this.regroupWan(this.incomeData.ad_income || 0, 2),
          yes: this.incomeData.yesterday_ad_income || 0,
        },
        {
          title: '广告曝光总次数',
          prop: 'ad_count',
          value: this.incomeData.ad_count || 0,
          yes: this.incomeData.yesterday_ad_count || 0,
        },
        {
          title: '贡献点收入',
          prop: 'contribution',
          value: this.regroupWan(this.incomeData.contribution || 0, 3),
          yes: this.incomeData.yesterday_contribution || 0,
        },
        {
          title: '迷你点收入',
          prop: 'minipoint',
          value: this.regroupWan(this.incomeData.minipoint || 0, 2),
          yes: this.incomeData.yesterday_minipoint || 0,
        },
        {
          title: '激励金总收入',
          prop: 'other',
          value: this.regroupWan(this.incomeData.other || 0, 2),
          yes: this.incomeData.yesterday_other || 0,
        },
      ];
    },
    //累计收益详情点击埋点
    allDClick() {
      this.$log('cumulative_revenue_details_click', 85421, { v7: 2 });
    },
    changeType(index) {
      this.dataType = index;
    },
    async fetchIncomeOverview() {
      this.loading = true;
      try {
        const res = await getIncomeOverview();
        this.incomeData = res.data;
        // this.updateDate = data.update_date;
        this.getCardList();
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    regroupWan(num, toFixed) {
      return _regroupWan(num, toFixed);
    },
    async fetchIncomeCard(type) {
      const res = await getIncomeCard({ card_type: type });
      type == 1
        ? (this.storDetailCard1 = res.data)
        : (this.storDetailCard2 = res.data);
    },
    getType(item) {
      let title = item.title;
      switch (title) {
        case '本月累计收入':
          this.dtype = 15;
          break;
        case '本月迷你豆收入':
          this.dtype = 11;
          break;
        case '广告总收入':
          this.dtype = 9;
          break;
        case '广告曝光总次数':
          this.dtype = 14;
          break;
        case '贡献点收入':
          this.dtype = 10;
          break;
        case '迷你点收入':
          this.dtype = 12;
          break;
        case '激励金收入':
          this.dtype = 13;
          break;
        case '收藏数':
          this.dtype = 8;
          break;
        case '投块数':
          this.dtype = 6;
          break;
        case '点赞数':
          this.dtype = 7;
          break;
        // eslint-disable-next-line no-duplicate-case
        case '广告总收入':
          this.dtype = 9;
          break;
        case '迷你豆数量':
          this.dtype = 11;
          break;
        case '迷你点数量':
          this.dtype = 12;
          break;
        case '贡献点数量':
          this.dtype = 10;
          break;
      }
    },
    getChartsData(list, dtype) {
      this.chartData.rows = [];
      // this.chartsTitle = this.overviewData[this.activeCard].title;
      console.log('debug:::', this.dateList);
      if (list.length) {
        this.dateList.forEach(date => {
          list.forEach(item => {
            if (date.date == item.date) {
              date = item;
            }
          });
          this.chartData.rows.push({
            日期: date.date,
            数据: dtype == 4 ? Number(date.num / 60).toFixed(2) : date.num || 0,
          });
        });
      }
      console.log('debug:::end', this.chartData);
    },
  },
};
</script>
<style
  src="../../../../assets/styles/InnerPageNav.less"
  lang="less"
  scoped
></style>
<style lang="less" scoped>
.overview-wrap {
  padding: 0px 0 63px 0;
  z-index: 9999;
  min-height: 100vh;
  .data-wrap {
    background: #fff;
    border-radius: 8px;
    padding: 24px 24px 0 24px;
  }
  .title-box {
    display: flex;
    margin-left: 4px;
    margin-right: 4px;
    align-items: center;
    .title {
      font-size: 30px;
      color: #000000;
      margin-right: 8px;
      font-weight: 500;
    }
    .date {
      color: #8c8c8c;
      font-size: 24px;
    }
  }
  .data-list-wrapper {
    //  height: 358px;
    .data-list {
      //    height: 358px;
      margin-top: 20px;
      //  overflow: hidden;
      flex-wrap: wrap;
      display: flex;
    }
    .data-item {
      //float: left;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      width: 208px;
      height: 184px;
      margin-right: 16px;
      margin-bottom: 16px;
      padding: 11px 24px;
      box-sizing: border-box;
      background: rgba(0, 0, 0, 0.02);
      // border: 1px solid #fafafa;
      border-radius: 8px;
      text-align: left;
      &.active {
        background-color: #fffaed;
        border: 2px solid #fd9b21;
      }
      &:nth-child(3n) {
        margin-right: 0;
      }

      .type {
        font-size: 26px;
        white-space: nowrap;
      }

      .num {
        padding: 2px 0;
        font-size: 36px;
        color: #fd9b21;
        font-weight: bold;
      }

      .prev-day {
        font-size: 24px;
        color: #8c8c8c;
      }
    }
  }
  .charts {
    width: 710px;
    // height: 529px;
    margin-top: 34px;
    margin-bottom: 50px;
    background: #ffffff;
    border-radius: 8px;
    .title {
      padding: 24px 0 24px 0;
      margin-left: 24px;
      margin-right: 24px;
      border-bottom: 1px solid #d8d8d8;
      font-size: 30px;
      font-weight: 500;
      color: #000000;
    }
  }
  .income-desc {
    margin-top: 56px;
    font-size: 24px;
    color: #8c8c8c;
    .item {
      line-height: 33px;
      margin-bottom: 12px;
    }
  }
}
.income-card-wrap {
  font-size: 24px;
  position: relative;
  color: #262626;
  // background-color: #fff;
  border-radius: 8px;
  padding: 20px 32px;
  .title-wrap {
    display: flex;
    margin-left: 4px;
    margin-right: 4px;
    align-items: center;
    .title {
      font-size: 34px;
      color: #000000;
      margin-right: 8px;
      font-weight: 500;
    }
    .date {
      color: #8c8c8c;
      font-size: 24px;
    }
  }
  .card-box {
    min-height: 170px;
    margin-top: 27px;
    white-space: nowrap;
    overflow-x: auto;
    .card-item {
      text-align: center;
      display: inline-block;
      background: #fafafa;
      border-radius: 8px;
      margin-right: 14px;
      padding: 16px 0;
      width: 200px;

      .card-name {
        font-size: 26px;
      }
      .card-total {
        font-size: 34px;
        color: #fd9b21;
        margin: 6px 0 11px;
      }
      .card-yes {
        font-size: 24px;
        color: #8c8c8c;
      }
    }
  }
  .income-explain {
    margin-top: 30px;
    color: #8c8c8c;
  }
}

.pop-wrap {
  width: 80%;
  font-size: 26px;
  padding: 30px;
  text-align: center;
  border-radius: 8px;
  .total-wrap {
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 39px;
    .total-num {
      font-size: 40px;
      color: #fd9b21;
      margin: 18px 0 26px;
    }
  }
  .content {
    padding: 0 22px;
    p {
      display: flex;
      justify-content: space-between;
      margin-bottom: 29px;
      span {
        display: flex;
        flex-direction: row;
        align-items: center;
        .th-img {
          width: 26px;
          height: 26px;
          margin-left: 6px;
        }
      }
    }
  }
  .tip-txt {
    margin-top: 88px;
    font-size: 24px;
    color: #8c8c8c;
    text-align: left;
  }
}
.img-loading {
  position: absolute;
  top: 40%;
  left: 50%;
}
</style>
<style lang="less">
.popoverItem {
  width: 300px;
  height: auto;
  overflow: hidden;
  white-space: normal;
}
</style>
